import Vue from "vue";
import VueToastr from "../components/alerts/index";

Vue.use(VueToastr);
export default  VueToastr;
